import { useEffect, useCallback, useState, useMemo } from 'react'
import { useWindowContext, Tabs, Row, Button, Message, noop } from '@iqueue/ui-kit'
import SettingCodeMirror from '../../components/settingsComponents/SettingCodeMirror'
import SettingsChipsContainer from '../../components/settingsComponents/SettingsChipsContainer'
import SettingsChips1 from '../../components/settingsComponents/SettingsChips/SettingsChips1'
import SettingsPresenter from '../../api/SettingsPresenter'
import './translations'
import useTranslate, { t } from '../../hooks/useTranslate'

const initialChips = [
  'devEUI',
  'serialNumber',
  'name',
  'status',
  'type',
  'limits_min',
  'limits_max',
  'thresholds_warn_min',
  'thresholds_warn_max',
  'thresholds_critical_min',
  'thresholds_critical_max',
  'applicationId',
  'deviceProfileId',
  'devAddr',
  'appKey',
  'nwkKey',
  'joinEui',
]

export default function SettingsPage() {
  const { setTitle, togglePaddings } = useWindowContext()
  const [activeTab, setActiveTab] = useState(1)
  const [chips, setChips] = useState(initialChips)
  const locale = useTranslate()

  const tabsConfig = useMemo(() => {
    return [
      { id: 1, title: t('settingsPage.tabs.tables') },
      { id: 2, title: t('settingsPage.tabs.parseExcel') },
      { id: 3, title: t('settingsPage.tabs.instantFlow') },
    ]
  }, [t, locale])

  const handleSaveChipsExcel = useCallback(() => {
    SettingsPresenter.post('sensors-excel-fields-order', {
      order: chips,
    }).then(() => {
      Message({
        type: 'success',
        timeout: 3000,
        title: t('settingsPage.messages.requestSuccess'),
      })
    }).catch(err => console.log(err))
  }, [chips])

  const translatedTitle = useMemo(() => t('menu.settings'), [locale])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(false)
  }, [translatedTitle])

  const renderTabContent = useCallback((id) => {
    switch (id) {
      case 1:
        return <SettingsChipsContainer/>
      case 2:
        return <div className={ 'main-chips-button' }>
          <SettingsChips1 chips={ chips } onChange={ setChips }/>

          <Row>
            <Button
              secondary
              size={ 12 }
              title={ t('settingsPage.chips.save') }
              onClick={ handleSaveChipsExcel }
            />
          </Row>
        </div>
      case 3:
        return <SettingCodeMirror/>
      default:
        return <div>{ t('settingsPage.messages.unknownTab') }</div>
    }
  }, [chips])

  return <div className="settings-tabs">
    <Tabs
      entries={ tabsConfig }
      current={ activeTab }
      render={(item) => {
        return {
          id: item.id,
          title: item.title,
        }
      }}
      onTabChanged={ (id) => setActiveTab(id) }
    />

    <div className="tab-content">
      { renderTabContent(activeTab) }
    </div>
  </div>
}
